import Vue from 'vue';
import Buefy from 'buefy';
import App from './App.vue';
import router from './router';
import store from './store';
import '@mdi/font/css/materialdesignicons.css'; // After using NPM audit fix, this runs into an error (I think the NPM audit fix might be to blame...)
import helpers from './helpers';
// const helpers = require('./helpers');

Vue.use(Buefy);
Vue.use(helpers);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
